import React from 'react';
import { Form } from 'react-bootstrap';

export interface SelectAllHeaderProps {
    isSelected: boolean;
    onChange(isSelected: boolean): void;
}

const SelectAllHeader: React.FC<SelectAllHeaderProps> = props => {

    return <div className="ag-header-cell-label">
        <Form.Check
            checked={props.isSelected}
            onChange={ev => props.onChange(ev.target.checked)} />
    </div>
}

export default SelectAllHeader;